import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">Powered by <b><a href="http://www.geniusws.com.br/" target="_blank">Genius Web Solutions ©</a></b> 2019</span>
    <div class="socials">
    <a href="https://br.linkedin.com/company/genius-web-solutions" target="_blank" class="ion ion-social-linkedin"></a>
      <a href="https://www.instagram.com/geniuswebsolutions/" target="_blank" class="ion ion-social-instagram"></a>
      <a href="https://www.facebook.com/geniusws/" target="_blank" class="ion ion-social-facebook"></a>
    </div>
  `,
})
export class FooterComponent {
}
